import { Tabs as MantineTabs, TabsProps as MantineTabsProps } from "@mantine/core";
import styles from "./styles.module.css";
import Group from "../Group";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "../Text";
import { ReactNode } from "react";

type DrawerTabsProps = Partial<MantineTabsProps> & {
  children: ReactNode;
};

const DrawerTabs = ({ children, ...props }: DrawerTabsProps) => {
  return (
    <MantineTabs
      inverted
      classNames={{
        root: styles.tabsRoot,
        tab: styles.tab,
        list: styles.list,
        panel: styles.panel,
      }}
      {...props}
    >
      {children}
    </MantineTabs>
  );
};

DrawerTabs.List = MantineTabs.List;
DrawerTabs.Tab = MantineTabs.Tab;
DrawerTabs.Panel = MantineTabs.Panel;

export default DrawerTabs;

interface DrawerTabProps {
  svgName?: string;
  label: string;
}
export const DrawerTab = ({ svgName, label }: DrawerTabProps) => {
  return (
    <Group>
      {svgName && <SVGAsset name={svgName} />}
      <Text size="xs">{label}</Text>
    </Group>
  );
};
